import img1 from "../img/user1.jpg";
import img2 from "../img/user2.jpg";
import img3 from "../img/user3.jpg";
import img4 from "../img/user4.jpg";

export const Followers = [
  { name: "Rachel Gray", username: "RachelGray", img: img1 },
  { name: "Jack Morgan", username: "JackMorgan", img: img2 },
  { name: "Julia Hill", username: "JuliaHill", img: img3 },
  { name: "Emma Gill", username: "EmmaGill", img: img4 },
];
